import { ComponentProps, JSX } from "react";
import AUSIcon from "../_icons/flags/ausIcon";
import USAIcon from "../_icons/flags/usaIcon";
import CANIcon from "../_icons/flags/canIcon";
import UkIcon from "../_icons/flags/ukIcon";
import IrelandIcon from "../_icons/flags/irelandIcon";

interface LanguageProps extends ComponentProps<"svg"> {
  locale: string;
  width: string;
  height: string;
}

const LanguageIcon = ({ locale, ...props }: LanguageProps) => {
  // add more icons when ready
  const countries: { [key: string]: JSX.Element } = {
    "en-us": <USAIcon {...props} />,
    "en-au": <AUSIcon {...props} />,
    "en-ca": <CANIcon {...props} />,
    "fr-ca": <CANIcon {...props} />,
    "en-gb": <UkIcon {...props} />,
    "en-ie": <IrelandIcon {...props} />,
  };

  return countries[locale.toLowerCase()] || null;
};
export default LanguageIcon;
